/**
 * GxLoading: the one waiting look (owner notes 22 Oct, item 5). A calm card with a slow light sweep and its words inside ("Running your year…"),
 * or the same words inline where a card would be too much. CSS only; with reduced motion the sweep stands still. `height` reserves the room of what replaces it.
 */
import { useEffect, useState, type CSSProperties } from "react";
import "./gx-loading.css";

/** A wait this long (ms) starts to say it is still going. */
export const SLOW_MS = 2_000;

export function GxLoading({ words, variant = "card", height, testId, className = "", slowWords }: {
  /** Plain words for what is being waited on, ending in an ellipsis ("Loading your results…"). */
  readonly words: string; readonly variant?: "card" | "inline";
  /** Card only: the height of what comes next, so the page does not jump when it arrives. */
  readonly height?: number; readonly testId?: string; readonly className?: string;
  /** What the wait says once it has run past SLOW_MS (default: "Still " + the words), so a long wait never reads as a stuck one. */
  readonly slowWords?: string;
}) {
  const [slow, setSlow] = useState(false);
  useEffect(() => { setSlow(false); const t = setTimeout(() => setSlow(true), SLOW_MS); return () => clearTimeout(t); }, [words]);
  const style: CSSProperties | undefined = height === undefined || variant === "inline" ? undefined : { minHeight: height };
  return (
    <div className={`gx-loading gx-loading--${variant} ${className}`.trim()} role="status" aria-live="polite" aria-busy="true" style={style} data-testid={testId}>
      <span className="gx-loading-dot" aria-hidden="true" />
      <span className="gx-loading-words">{slow ? slowWords ?? `Still ${words.charAt(0).toLowerCase()}${words.slice(1)}` : words}</span>
    </div>
  );
}
